/* FOM · historico local de desfazer/refazer (Fase 1S).

   O QUE ISTO E — e o que ele deliberadamente NAO e.

   Ctrl+Z aqui NAO apaga historia. Toda operacao ja persistida continua na
   trilha de auditoria para sempre (append-only, I-5). Desfazer e uma NOVA
   operacao, feita pelos mesmos caminhos reais da API:

     criar no      -> desfazer OCULTA (remocao logica) -> refazer RESTAURA
     editar no     -> desfazer reaplica os valores anteriores, com
                      expected_updated_at do estado que este fluxo produziu
     criar relacao -> desfazer remove -> refazer cria de novo (id novo)
     mover no      -> desfazer devolve a posicao anterior
     ocultar no    -> desfazer restaura -> refazer oculta

   CONFLITO NAO SE ATROPELA. Se o servidor mudou desde a operacao (outra
   pessoa, outra aba), o `expected_updated_at` gravado aqui ja nao bate, o
   servidor responde 409, e este modulo DESCARTA a entrada e propaga o erro
   para a tela explicar. Forcar o undo por cima seria sobrescrever trabalho
   alheio — exatamente o que a concorrencia otimista existe para impedir.

   A pilha e LOCAL e por sessao de tela: F5 comeca vazia. Ela nao e fonte de
   verdade de nada — o banco e. */

export type AcaoLocal = {
  rotulo: string;
  desfazer: () => Promise<void>;
  refazer: () => Promise<void>;
};

export function criarHistoricoLocal(limite = 50) {
  const desfeitos: AcaoLocal[] = [];   /* pilha de undo */
  const refeitos: AcaoLocal[] = [];    /* pilha de redo */
  let ocupado = false;

  return {
    /* Toda mutacao bem-sucedida registra a sua inversa. Uma acao NOVA apaga a
       pilha de redo: refazer um futuro que divergiu do presente nao existe. */
    registrar(acao: AcaoLocal): void {
      desfeitos.push(acao);
      if (desfeitos.length > limite) desfeitos.shift();
      refeitos.length = 0;
    },

    async desfazer(): Promise<string | null> {
      if (ocupado) return null;
      const acao = desfeitos.pop();
      if (!acao) return null;
      ocupado = true;
      try {
        await acao.desfazer();
        refeitos.push(acao);
        return acao.rotulo;
      } catch (err) {
        /* a entrada morre: o estado que ela sabia desfazer ja nao existe.
           Reenfileirar produziria o mesmo conflito em loop. */
        throw err;
      } finally {
        ocupado = false;
      }
    },

    async refazer(): Promise<string | null> {
      if (ocupado) return null;
      const acao = refeitos.pop();
      if (!acao) return null;
      ocupado = true;
      try {
        await acao.refazer();
        desfeitos.push(acao);
        return acao.rotulo;
      } finally {
        ocupado = false;
      }
    },

    get podeDesfazer(): boolean { return desfeitos.length > 0; },
    get podeRefazer(): boolean { return refeitos.length > 0; },
    get tamanho(): number { return desfeitos.length; },
  };
}

export type HistoricoLocal = ReturnType<typeof criarHistoricoLocal>;
